import {Metadata} from './core.entity.metadata';

export class EntityMananger {
    private static _entitesNameClass: Map<string, string> = new Map<string, string>();
    private static _columns: Map<string, Map<string, Metadata>> = new Map<string, Map<string, Metadata>>();
    private static _entites: Map<string, any> = new Map<string, any>();
    private static _entitesName: Map<string, string> = new Map<string, string>();

    public static register(entity: any) {
        EntityMananger._entites.set(entity.name, entity);
    }

    public static get(token: string) {
        return EntityMananger._entites.get(token);
    }

    public static registerEntityColumns(token: string, column: Metadata) {
        const entityColumns = EntityMananger.getEntityColumns(token);
        entityColumns.set(column.columnName, column);
    }

    public static getAll() {
        return EntityMananger._entites;
    }

    public static getEntityColumn(token: string, columnName: string) {
        const entityColumns = EntityMananger.getEntityColumns(token);

        if (!entityColumns.has(columnName))
            return new Metadata();

        return entityColumns.get(columnName);
    }

    public static translate(token: string): string {
        return EntityMananger._entitesName.get(token);
    }

    public static translateClassToName(token: string): string {
        return EntityMananger._entitesNameClass.get(token);
    }

    public static getEntityColumns(token: string, translate: boolean = false) {
        token = translate ? EntityMananger.translate(token) : token;
        if (!EntityMananger._columns.has(token))
            EntityMananger._columns.set(token, new Map<string, Metadata>());

        return EntityMananger._columns.get(token);
    }

    public static registerEntity(token: string, className: string) {
        EntityMananger._entitesName.set(token, className);
        EntityMananger._entitesNameClass.set(className, token);
    }
}
